export default __webpack_public_path__ + "static/summit-landing-hero-64264ba54019bbcdc7fcc397931d3500.png";